import type { IContextBindingService, IContextBindingServiceConfig } from './contextBindingService'
import type { ICompChangeStore } from '../types'

export const createContextBindingService = (
	config: IContextBindingServiceConfig,
	store?: ICompChangeStore
): IContextBindingService => {
	return {
		getBindings: (compId: string) => {
			return config.compIdToBindingMap[compId] || []
		},
		subscribeToBindingChanges: (compId: string, callback: () => void) => {
			if (!store) {
				return () => {}
			}
			return store.subscribeToChanges(compId, callback)
		},
	}
}
